<script>
    export default {
        name: 'drawer',

        props: {
            title: {
                default: '[no title provided]'
            }
        }

    }
</script>

<template>
    <li class="m-drawers__item" role="tab" tabindex="0" data-accordion-item>
        <a class="m-drawers__toggle" href="#" aria-controls="--"><span>{{ title }}</span></a>
        <div class="m-drawers__toggle-wrapper" role="tabpanel" aria-labelledby="--" data-tab-content>
            <div class="m-drawers__content">
                <slot></slot>
            </div>
        </div>
    </li>
</template>
